import {React, useContext, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import SLUGS from '../slugs';
import {
    IconAgents,
    IconOverview,
    IconSettings,
    IconSubscription,   
} from '../../assets/icons';
import { convertSlugToUrl } from '../../utils/utilities';
import LogoComponent from './LogoComponent';
import Menu from './MenuComponent';
import MenuItem from './MenuItemComponent';
import AuthNav from "../../services/auth/components/auth-nav"
import { useAuth0 } from "@auth0/auth0-react";
import {SidebarContext} from "../hooks/useSidebar"
import { default as Box } from '@mui/material/Box';
import { Column, Row } from 'simple-flexbox';
import { createUseStyles, useTheme } from 'react-jss';

const useStyles = createUseStyles({
  
    container: {
        display: 'flex',
        height: 56,
        cursor: 'pointer',
        paddingLeft: 80,
        transition: 'all 0.2s ease-in-out'
    },
    title: {
        fontSize: 16,
        lineHeight: '20px',
        letterSpacing: '0.2px',
        marginLeft: 24
    }
});


function SidebarComponent() {
    const navigate = useNavigate();
    let isMobile = window.innerWidth <= 1080;
    // const { isAuthenticated} = useAuth0();
    // const {currentItem} = useContext(SidebarContext);
    const classes = useStyles();

    useEffect(() => {

    
    },[])

    function onClick(slug, parameters = {}) {         
        navigate(convertSlugToUrl(slug, parameters));
    }

    return (
        <Menu isMobile={true}>
            <div style={{ paddingTop: 30, paddingBottom: 30 }}>
                <LogoComponent />
            </div>            
            <MenuItem
                id={SLUGS.root}                
                title='Visualisering'
                icon={IconOverview}
                onClick={() => onClick(SLUGS.root)}
            >               
            </MenuItem>  
{/*            
                <MenuItem
                id={SLUGS.visualisering}
                title='Visualisering'
                icon={IconSubscription}
                onClick={() => onClick(SLUGS.visualisering)}
                />
         */}
            {/* {isAuthenticated &&  (            
            <MenuItem
                id={SLUGS.users}
                items={[SLUGS.user, SLUGS.newUser,SLUGS.profileInfo,'/users/']}
                title='Brugerer'
                icon={IconAgents}
            >
                <MenuItem
                    id={SLUGS.users}
                    title='Brugere'
                    items={[SLUGS.newUser, '/users/']}
                    level={2}
                    icon={IconAgents}
                    onClick={() => onClick(SLUGS.users)}
                />                
                <MenuItem
                    id={SLUGS.profileInfo}
                    title='Profil'
                    level={2}
                    icon={IconAgents}
                    onClick={() => onClick(SLUGS.profileInfo)}
                />                
            </MenuItem>)} */}
            {/* {isAuthenticated &&  (<MenuItem
                id={SLUGS.settings}
                title='Indstillinger'
                icon={IconSettings}
                onClick={() => onClick(SLUGS.settings)}
            /> )}     */}
            {/* {isAuthenticated &&  (<MenuItem
                id={SLUGS.customerHandling}
                items={[SLUGS.newCustomer, '/customers/']}
                title='Kunder'
                icon={IconAgents}
                onClick={() => onClick(SLUGS.customerHandling)}
            /> )}         */}
             <Column>
                <Row vertical='center' className={classes.container}>
                    <AuthNav  /> 
                </Row>
            </Column> 
                    
        </Menu>        
    );
}

export default SidebarComponent;
